<div class="modal-header">
  <h5 class="modal-title">Address</h5>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body p-0">
  <div class="autocomplete-container p-3">
  <input
    type="text"
    class="form-control"
    placeholder="Search address..."
    [(ngModel)]="autocompleteQuery"
    (input)="updateSearchResults()"
  />

  <ul *ngIf="autocompleteItems.length" class="list-group mt-2">
    <li
      *ngFor="let item of autocompleteItems"
      class="list-group-item list-group-item-action"
      (click)="selectAutocomplete(item)"
    >
      {{ item.description }}
    </li>
  </ul>
</div>

  <google-map height="400px" width="100%"
    [center]="center"
    [zoom]="zoom"
    (mapClick)="onMapClick($event)">
    <map-marker *ngIf="markerPos" [position]="markerPos"></map-marker>
  </google-map>

  <div class="mt-2 px-3">
  <small *ngIf="selectedAddress">📍 {{ selectedAddress }}</small>
</div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
  <button class="btn btn-primary" [disabled]="!markerPos" (click)="confirm()">Confirm</button>
</div>
